import { extendZodWithOpenApi } from '@anatine/zod-openapi';
import { z } from 'zod';

extendZodWithOpenApi(z);

export type CategoryEnums = z.infer<typeof CategoryEnumSchema>;
export type EmbeddedCategoryLight = z.infer<typeof EmbeddedCategoryLightSchema>;

// Keep up to date with values in the database for best type checking
// We may want to consider reading `dbCategories` from apps/integration-cloud/seeding/categories
// to dynamically generate this enum, but unsure of implications.
export const CategoryEnumSchema = z.enum([
  // Business & Management
  'management',
  'operations',
  'finance',
  'accounting',
  'hr',
  'legal',
  'compliance',
  'calendar',
  'timetracking',
  'spreadsheet',
  'word_processing',

  // Communication & Media
  'communication',
  'news',
  'social',
  'video',
  'video_conferencing',
  'presentation',
  'music',

  // Product & Design
  'product',
  'design',
  'branding',
  'media_editing',
  'prototyping',
  'wireframing',
  'project_management',

  // Development & Technology
  'engineering',
  'developer_tools',
  'security',
  'cms',
  'analytics',

  // Sales & Marketing
  'sales',
  'marketing',
  'ecommerce',

  // Support & Service
  'support',
  'ticketing',

  // Specific Sectors
  'banking',
  'gaming',
  'sport',

  // Productivity & Tools
  'ats',
  'crm',
  'notes',
  'invoicing',
  'knowledge_base',
  'payment',
  'productivity',
  'storage',
  'surveys',
  'utilities',
  'browser',

  // Logistics
  'logistics',

  // Location Tracking (e.g, GPS tracking from Timely)
  'location_tracking',
]);

export const EmbeddedCategoryLightSchema = z.object({
  id: CategoryEnumSchema.openapi({ description: 'Category ID', example: 'design' }),
  title: z.string().openapi({ description: 'Category title', example: 'Developer Tools' }),
  icon_url: z
    .string()
    .describe('Category icon URL')
    .openapi({
      example: 'https://...',
    })
    .optional(),
});
